/**
 * A phone's controls in the call (decision 162): the call's bar, the coach's tools rail (and the match
 * player's own bar, by its own rule) hide after CHROME_HIDE_MS without a touch, and a tap on the stage shows
 * or hides them. A tap that shows them does nothing else: it never presses what is under it. A tap on a
 * control does its job and keeps them shown. Pure, so tested.
 */
export const CHROME_HIDE_MS = 3000;

export function chromeTap(p: { shown: boolean; onControl: boolean }): { shown: boolean; swallow: boolean } {
  if (!p.shown) return { shown: true, swallow: true };
  if (p.onControl) return { shown: true, swallow: false };
  return { shown: false, swallow: false };
}

/** What counts as a control under a tap: anything pressable, a slider or a scrubber, a sheet, the self tile, the chat. */
export const CONTROL_SELECTOR = 'button, a, input, textarea, select, [role="slider"], [role="dialog"], [data-scrubber], [data-self-view], [data-room-chat]';
